import styled from 'styled-components'
import { WrapperProps } from './types'

const VALIDATION_NO_INFO_HEIGHT = 0
const VALIDATION_SINGLE_INFO_HEIGHT = 38
const VALIDATION_DOUBLE_INFO_HEIGHT = 64
export const VALIDATION_INFO_HEIGHTS = [
  VALIDATION_NO_INFO_HEIGHT,
  VALIDATION_SINGLE_INFO_HEIGHT,
  VALIDATION_DOUBLE_INFO_HEIGHT
]
export const VALIDATION_BUTTON_HEIGHT = 48
export const VALIDATION_TOS_HEIGHT = 52

export const Wrapper = styled.div.attrs(({ paddingBottom }: WrapperProps) =>
  (paddingBottom !== undefined && paddingBottom !== 0)
    ? ({ style: { paddingBottom: `${paddingBottom}px` } })
    : undefined
)`
  color: ${({ theme }) => theme.colors.text.body};
  font-family: ${({ theme }) => theme.typography.body.text.fontFamily};
  font-size: ${({ theme }) => theme.typography.body.text.fontSize};
  font-weight: ${({ theme }) => theme.typography.body.text.fontWeight};
  line-height: ${({ theme }) => theme.typography.body.text.lineHeight};
`
